import { zonedTimeToUtc } from 'date-fns-tz';

const MILLISECONDS_IN_MINUTE = 60000,
  TIMEZONE = 'Europe/Helsinki';

function toInteger(dirtyNumber: unknown) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  const number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

export function toTimezoneDate(dirtyDate: Date | number | string) {
  return zonedTimeToUtc(dirtyDate, TIMEZONE);
}

export function addMilliseconds(
  dirtyDate: Date | number,
  dirtyAmount: number
): Date {
  const timestamp = toTimezoneDate(dirtyDate).getTime();
  const amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

export function addMinutes(
  dirtyDate: Date | number,
  dirtyAmount: number
): Date {
  const amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}
